import service from '@/middleware'

const driveUnitApi = {
    /**
     * Para crear una nueva unidad de manejo
     * @param {*} driveUnit
     */
    async create (zoneId,  driveUnit) {
        const body = {
            zoneId,
            driveUnit
        }
        const result = await service.http.post(`/api/drive-unit/create`, body)
        return result
    },

    /**
     * Para obtener una unidad de manejo según el id de zona
     * @param {*} zoneId 
     */
    async getDriveUnitByZoneId (zoneId) {
        const result = await service.http.get(`/api/drive-unit/find-by-zone/${zoneId}`)
        return result
    },

    /**
     * Método para actualizar la unidad de manejo
     * @param {*} driveUnit 
     * @param {*} driveUnitId
     */
    async update (driveUnit, driveUnitId) {
        const body = {
            driveUnitId,
            driveUnit
        }
        const result = await service.http.put(`/api/drive-unit/update`, body)
        return result
    },
    /**
     * Para eliminar una UM por zoneId
     * @param {*} zoneId
     */
    async deleteOne(zoneId) {
        const result = await service.http.delete(`/api/drive-unit/${zoneId}`)
        return result
    },
    /**
     * Eliminación múltiple por zoneIds
     * @param {*} zoneIds
     */
    async deleteMany(zoneIds) {
        const result = await service.http.put(`/api/drive-unit/multiple-delete`, zoneIds)
        return result
    }
}

export default driveUnitApi
